document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-roussa-swipe]").forEach((media) => {
    const track = media.querySelector(".roussa-swipe__track");
    const dotsWrap = media.parentElement?.querySelector("[data-roussa-dots]");
    if (!track || !dotsWrap) return;

    const dots = Array.from(dotsWrap.querySelectorAll("button"));
    const slides = Array.from(track.querySelectorAll(".roussa-swipe__slide"));
    if (slides.length < 2) return;

    const setActive = (idx) => {
      dots.forEach((b, i) => b.classList.toggle("is-active", i === idx));
    };

    const scrollToIdx = (idx) => {
      const w = track.clientWidth;
      track.scrollTo({ left: idx * w, behavior: "smooth" });
      setActive(idx);
    };

    dots.forEach((btn, idx) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        scrollToIdx(idx);
      });
    });

    let ticking = false;
    track.addEventListener("scroll", () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const idx = Math.round(track.scrollLeft / track.clientWidth);
        setActive(Math.max(0, Math.min(idx, slides.length - 1)));
        ticking = false;
      });
    });
  });
});
